<div class="content-container">
    <mat-card class="login-component">
        <mat-card-header class="login-header">
            <mat-card-title class="mat-card-title">
                <mat-icon class="material-symbols-outlined">
                    network_node    
                </mat-icon>
                <span>
                    Edit Node {{ itemEnvelope?.ItemId }}: {{ itemEnvelope?.ItemName }}
                </span>
            </mat-card-title>
            <mat-card-subtitle class="mat-card-subtitle">
                Edit the {{ itemEnvelope?.Document?.Item?.DisplayText }} node including route path, icon etc
            </mat-card-subtitle>
        </mat-card-header>
        <mat-card-content>
            <form>
                <mat-form-field appearance="outline">
                    <mat-label>Name</mat-label>
                    <input matInput *ngIf="itemEnvelope" name="Name" placeholder="Name" [(ngModel)]="itemEnvelope.Document.Item.Name" />
                </mat-form-field>
                <br />
                <mat-form-field appearance="outline">
                    <mat-label>Description</mat-label>
                    <input matInput *ngIf="itemEnvelope" name="Description" placeholder="Description" [(ngModel)]="itemEnvelope.Document.Item.Description" />
                </mat-form-field>
                <br />
                <mat-tab-group>
                    <mat-tab label="General Properties">
                        <br />
                        <mat-form-field appearance="outline">
                            <mat-label>Parent Node Id</mat-label>
                            <input matInput *ngIf="itemEnvelope" name="ParentNodeId" placeholder="(ParentNodeId [number])" [(ngModel)]="itemEnvelope.Document.Item.ParentNodeId" />
                        </mat-form-field>
                        <br />
                        <mat-form-field appearance="outline">
                            <mat-label>Display Text</mat-label>
                            <input matInput *ngIf="itemEnvelope" name="DisplayText" placeholder="(Display Text)" [(ngModel)]="itemEnvelope.Document.Item.DisplayText" />
                        </mat-form-field>
                        <br />
                        <mat-form-field appearance="outline">
                            <mat-label>Route</mat-label>
                            <input matInput *ngIf="itemEnvelope" name="Route" placeholder="(Angular Route)" [(ngModel)]="itemEnvelope.Document.Item.Route" />
                        </mat-form-field>
                        <br />
                        <mat-form-field appearance="outline">
                            <mat-label>Sort Oder</mat-label>
                            <input matInput *ngIf="itemEnvelope" name="SortOrdinal" placeholder="(Sort Order)" [(ngModel)]="itemEnvelope.Document.Item.SortOrdinal" />
                        </mat-form-field>
                        <mat-form-field appearance="outline">
                            <mat-label>Icon Name</mat-label>
                            <input matInput *ngIf="itemEnvelope" name="IconName" placeholder="(Material icon name)" [(ngModel)]="itemEnvelope.Document.Item.IconName" />
                        </mat-form-field>
                    </mat-tab>
                    <mat-tab label="Roles">
                        <br />
                        <br />
                        <span>
                            <mat-form-field>
                                <mat-label>Available Roles</mat-label>
                                <mat-select *ngIf="itemEnvelope" name="AvailableRoles" [(ngModel)]="selectedRole">
                                    <mat-option *ngFor="let role of availableRoles" [value]="role">{{ role.UID }}</mat-option>
                                </mat-select>
                            </mat-form-field>
                            <button mat-button (click)="addSelectedRoleToNode()" [disabled]="this.selectedRole == null">
                                <mat-icon class="material-symbols-outlined">
                                    add
                                </mat-icon>
                                ADD ROLE
                            </button>
                        </span>
                        <br />
                        <table mat-table [dataSource]="nodeRolesDatasource" class="mat-elevation-z8" matSort>
                            <ng-container matColumnDef="Avatar">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let role">
                                    <mat-icon class="material-symbols-outlined">
                                        work
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <ng-container matColumnDef="Role">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header> Name </th>
                                <td mat-cell *matCellDef="let nodeRole">{{ getRoleUIDFromRoleId(nodeRole.RoleId) }}</td>
                            </ng-container>
                            <ng-container matColumnDef="Delete">
                                <th mat-header-cell *matHeaderCellDef mat-sort-header></th>
                                <td mat-cell *matCellDef="let nodeRole">
                                    <mat-icon class="material-symbols-outlined" (click)="deleteRole(nodeRole)">
                                        delete
                                    </mat-icon>
                                </td>
                            </ng-container>
                            <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
                            <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
                        </table>
                        <mat-paginator [pageSizeOptions]="[5, 10, 100]" aria-label="Select page of items"></mat-paginator>
                    </mat-tab>
                    <mat-tab label="History">
                        <br />
                        <app-history *ngIf="this.itemEnvelope" [itemEnvelope]="this.itemEnvelope"></app-history>
                    </mat-tab>
                </mat-tab-group>
            </form>
        </mat-card-content>
        <mat-card-footer>
        </mat-card-footer>
    </mat-card>
</div>
